import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { callApi } from '../../utils/callApi';
import { ApiEvents } from '../../utils/SocketEvents';
import { GetTechnicalTexts, TypeGetTechnicalTextsActionR } from './actions';
import ActionTypes, { TTechnicalTextsState } from './types';

function* getTechnicalTextsWorker(action: ReturnType<typeof GetTechnicalTexts.request>): Generator {
  const { data, callBack } = action.payload as TypeGetTechnicalTextsActionR;

  let success = true;
  try {
    const resp = (yield call(callApi, {
      method: 'post',
      data,
      path: ApiEvents.getTechnicalTexts,
    })) as TTechnicalTextsState['data'];
    yield put(GetTechnicalTexts.success(resp));
  } catch (e) {
    success = false;
    yield put(GetTechnicalTexts.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* watchRequest() {
  yield takeEvery(ActionTypes.GET_TECHNICAL_TEXTS_R, getTechnicalTextsWorker);
}

export default function* technicalTextsSaga() {
  yield all([fork(watchRequest)]);
}
